import { Action } from 'redux'
import { ICurrency } from '../../models/Currency'
import { CurrencyActions } from '../../reducers/currency/actionNames'

const requestForCurrency = (): IRequestForCurrency => ({
  type: CurrencyActions.RequestForCurrency,
})

export interface IRequestForCurrency
  extends Action<CurrencyActions.RequestForCurrency> {
  type: CurrencyActions.RequestForCurrency
}

export default requestForCurrency

export const dataForCurrencyIsAccepted = (
  data: ICurrency[],
): IDataForCurrencyIsAccepted => ({
  currency: data,
  type: CurrencyActions.RequestForCurrencyIsAccepted,
})

export interface IDataForCurrencyIsAccepted
  extends Action<CurrencyActions.RequestForCurrencyIsAccepted> {
  currency: ICurrency[]
}

export const dataForCurrencyIsRejected = (
  errMessage: string,
): IDataForObjectIsRejected => ({
  errMessage,
  type: CurrencyActions.RequestForCurrencyIsRejected,
})

export interface IDataForObjectIsRejected
  extends Action<CurrencyActions.RequestForCurrencyIsRejected> {
  errMessage: string
}
